module.exports = __webpack_public_path__ + "img/charity-bar.06074f6c.png";